if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      connectedCallback() {
        if (this.moved) return;
        this.advisorModal = this.closest('quick-add-modal[data-advisor-modal]');
        if (!this.advisorModal) {
          super.connectedCallback();
          return;
        }

        // The advisor already lives in body, outside its original Shopify section.
        this.dataset.section = this.closest('product-info').dataset.section;
        this.moved = true;
        this.advisorModal.mediaModal?.remove();
        this.advisorModal.mediaModal = this;
        document.body.appendChild(this);
      }

      hide() {
        if (!this.hasAttribute('open')) return;
        super.hide();
        if (this.advisorModal?.hasAttribute('open')) {
          document.body.classList.add('overflow-hidden');
          trapFocus(this.advisorModal, this.openedBy);
        }
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
